/* eslint-disable max-lines */
import { UserInfo } from '@/types';
import { AccessMasterRolesEnum, BusinessRolesEnum, TechnicalRolesEnum } from '@/types/enum/RoleEnum';
import { hasRolesForProject } from '@/config/plugins/vue-browser-acl';
import { PagePermissionEnum } from '@/types/enum/PermissionEnum';
import loginService from '@/services/Security/loginService';

export default function setPagePermission(acl: any) {
	acl.rule(PagePermissionEnum.CONNECTED, (user: UserInfo) => user);

	acl.rule(PagePermissionEnum.PROJECT_LIST, (user: UserInfo) => user && (
		loginService.isLogged() ||
		user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
	));

	acl.rule(PagePermissionEnum.PATIENT, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.PATIENT_ADD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.PATIENT_LIST, user, project)
		)
	);

	acl.rule(PagePermissionEnum.PATIENT_PCR, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.ADDRESSING_LIST, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.ADDRESSING_ADD, user, project)
		)
	);

	acl.rule(PagePermissionEnum.PATIENT_IDEL, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.IDEL_PATIENT_LIST, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.IDEL_PATIENT_ADD, user, project)
		)
	);

	acl.rule(PagePermissionEnum.PATIENT_IDEL_VALIDATOR, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.IDEL_PATIENT_LIST_VALIDATOR, user, project)
		)
	);

	acl.rule(PagePermissionEnum.DATA_LINES_LIST, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.DATA_LINE_ADD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.DATA_LINE_LIST, user, project)
		)
	);

	acl.rule(PagePermissionEnum.PATIENT_FILE, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.PATIENT_FILE, user, project)
		)
	);

	acl.rule(PagePermissionEnum.PROJECT, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(BusinessRolesEnum.ADMIN_LOCAL, user, project) ||
			hasRolesForProject(BusinessRolesEnum.ADMIN_LOCAL_CLOSED, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(PagePermissionEnum.ACTORS_LIST, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.ACTOR_ADD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.ACTOR_EDIT, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.ACTOR_DELETE, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.ACTOR_LIST, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(PagePermissionEnum.USERS_ACTORS_LIST, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.USER_ACTOR_ADD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.USER_ACTOR_LIST, user, project)
		) &&
		(
			false === hasRolesForProject(BusinessRolesEnum.SUPERVISOR_IDEL, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.USER_ACTOR_LIST, user, project)
		)
	);

	acl.rule(PagePermissionEnum.IDEL_ACTORS_LIST, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.IDEL_ACTOR_ADD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.IDEL_ACTOR_LIST, user, project)
		) &&
		(
			hasRolesForProject(BusinessRolesEnum.SUPERVISOR_IDEL, user, project) ||
			hasRolesForProject(BusinessRolesEnum.SUPERVISOR_IDEL_CLOSED, user, project
			)
		)
	);

	acl.rule(PagePermissionEnum.IMPORT_STORED_FILE, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.FILE_STORAGE_DELETE, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.FILE_STORAGE_ADD, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(PagePermissionEnum.IMPORT_STORED_FILE_LIST, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.FILE_STORAGE_LIST, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.FILE_STORAGE_DOWNLOAD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.FILE_STORAGE_VIEW, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(PagePermissionEnum.IMPORT_CONTROL_FILE, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.CONTROL_IMPORTER_DOWNLOAD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.CONTROL_IMPORTER_VIEW, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.CONTROL_IMPORTER_LIST, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(PagePermissionEnum.IMPORT_CONTACT, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.CONTACT_ADD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.CONTACT_DELETE, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.CONTACT_DOWNLOAD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.CONTACT_LIST, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.CONTACT_VIEW, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(PagePermissionEnum.IMPORT, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.IMPORTER_ADD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.IMPORTER_DELETE, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.ACTOR_IMPORTER_DELETE, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.ACTOR_IMPORTER_ADD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.PCR_IMPORTER_ADD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.CONTACT_ADD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.CONTACT_DELETE, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.FILE_STORAGE_DELETE, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.FILE_STORAGE_ADD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.CONTROL_IMPORTER_ADD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.CONTROL_IMPORTER_DELETE, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(PagePermissionEnum.IMPORT_LIST, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.IMPORTER_LIST, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.IMPORTER_VIEW, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.IMPORTER_DOWNLOAD, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(PagePermissionEnum.REMUNERATION, 'Project', (user: UserInfo) =>
		user &&
		user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
	);

	acl.rule(PagePermissionEnum.PROJECT_PAYMENTS_LIST, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN) ||
			hasRolesForProject(TechnicalRolesEnum.PAYMENT_LIST, user, project)
		)
	);

	acl.rule(PagePermissionEnum.PROJECT_EXPORTS_LIST, 'Project', (user: UserInfo, project: any) =>
		user && hasRolesForProject(TechnicalRolesEnum.EXPORT_LIST, user, project)
	);

	acl.rule(PagePermissionEnum.PAYMENTS_LIST_EXP, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_VALIDATOR) ||
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR_MANAGER) ||
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR) ||
			user.roles.includes(AccessMasterRolesEnum.CPAM_SUPERVISOR) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(PagePermissionEnum.PAYMENTS_LIST_PCR, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_VALIDATOR) ||
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR_MANAGER) ||
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR) ||
			user.roles.includes(AccessMasterRolesEnum.CPAM_SUPERVISOR) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(PagePermissionEnum.PAYMENTS_LIST_DGOS, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_DGOS) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN) ||
			user.roles.includes(AccessMasterRolesEnum.CPAM_SUPERVISOR)
		)
	);

	acl.rule(PagePermissionEnum.EXPORTS_ADMINISTRATION, (user: UserInfo) =>
		user &&
		user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
	);

	acl.rule(PagePermissionEnum.EXPORTS_LIQUIDATION, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR) ||
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR_MANAGER)
		)
	);

	acl.rule(PagePermissionEnum.EXPORTS_SUPERVISION, (user: UserInfo) =>
		user &&
		user.roles.includes(AccessMasterRolesEnum.CPAM_SUPERVISOR)
	);

	acl.rule(PagePermissionEnum.EXPORTS_VALIDATION, (user: UserInfo) =>
		user &&
		user.roles.includes(AccessMasterRolesEnum.NATIONAL_VALIDATOR)
	);

	acl.rule(PagePermissionEnum.EXPORTS_EVAL_TC, (user: UserInfo) =>
		user &&
		user.roles.includes(AccessMasterRolesEnum.EVALUATION_TC)
	);

	acl.rule(PagePermissionEnum.EXPORTS_EVAL_DM, (user: UserInfo) =>
		user &&
		user.roles.includes(AccessMasterRolesEnum.EVALUATION_DM)
	);

	acl.rule(PagePermissionEnum.EXPORTS_CONTROL_FILE_TC, (user: UserInfo) =>
		user &&
		user.roles.includes(AccessMasterRolesEnum.EVALUATION_TC)
	);

	acl.rule(PagePermissionEnum.EXPORTS_CONTROL_FILE_DM, (user: UserInfo) =>
		user &&
		user.roles.includes(AccessMasterRolesEnum.EVALUATION_DM)
	);

	acl.rule(PagePermissionEnum.PAYMENTS_VALIDATION_EXP, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_VALIDATOR)
		)
	);

	acl.rule(PagePermissionEnum.PAYMENTS_LIQUIDATION_EXP, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR_MANAGER) ||
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR)
		)
	);

	acl.rule(PagePermissionEnum.PAYMENTS_SUPERVISION_EXP, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.CPAM_SUPERVISOR)
		)
	);

	acl.rule(PagePermissionEnum.PAYMENTS_SUPERVISION_DGOS, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.CPAM_SUPERVISOR)
		)
	);

	acl.rule(PagePermissionEnum.PAYMENTS_VALIDATION_PCR, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_VALIDATOR)
		)
	);

	acl.rule(PagePermissionEnum.PAYMENTS_LIQUIDATION_PCR, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR_MANAGER) ||
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR)
		)
	);

	acl.rule(PagePermissionEnum.PAYMENTS_SUPERVISION_PCR, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.CPAM_SUPERVISOR)
		)
	);

	acl.rule(PagePermissionEnum.PAYMENTS_VALIDATION_DGOS, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_DGOS)
		)
	);

	acl.rule(PagePermissionEnum.IMPORT_ADMINISTRATION, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(PagePermissionEnum.PROJECT_GROUP, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_VALIDATOR)
		)
	);

	acl.rule(PagePermissionEnum.PAYMENTS_ADMINISTRATION_EXP, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(PagePermissionEnum.PAYMENTS_ADMINISTRATION_PCR, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(PagePermissionEnum.PAYMENTS_ADMINISTRATION_DGOS, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(PagePermissionEnum.DIRECT_IMPORT_UNDUE, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);

	acl.rule(PagePermissionEnum.PAYMENT_ADD, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);
	acl.rule(PagePermissionEnum.DIRECT_IMPORT_PATIENT, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);
	acl.rule(PagePermissionEnum.DOC, (user: UserInfo) =>
		user &&
		(
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);
	acl.rule(PagePermissionEnum.IMPORT_ACTOR, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.ACTOR_IMPORTER_ADD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.ACTOR_IMPORTER_DELETE, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.ACTOR_IMPORTER_DOWNLOAD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.ACTOR_IMPORTER_LIST, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.ACTOR_IMPORTER_VIEW, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);
	acl.rule(PagePermissionEnum.IMPORT_PCR, 'Project', (user: UserInfo, project: any) =>
		user &&
		(
			hasRolesForProject(TechnicalRolesEnum.PCR_IMPORTER_ADD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.PCR_IMPORTER_DELETE, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.PCR_IMPORTER_DOWNLOAD, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.PCR_IMPORTER_LIST, user, project) ||
			hasRolesForProject(TechnicalRolesEnum.PCR_IMPORTER_VIEW, user, project) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);
	acl.rule(PagePermissionEnum.EXPORTS_PAYMENT, 'Project', (user: UserInfo, project: any) =>
		user && hasRolesForProject(TechnicalRolesEnum.EXPORT_PAYMENT_LIST, user, project)
	);
	acl.rule(PagePermissionEnum.SURVEY_CAMPAIGN, 'Project', (user: UserInfo, project: any) =>
		user && hasRolesForProject(TechnicalRolesEnum.SURVEY_CAMPAIGN_VIEW, user, project)
	);
	acl.rule(PagePermissionEnum.EXPERIENCE_PATIENT_ADMINISTRATION, (user: UserInfo) =>
		user && (
			user.roles.includes(AccessMasterRolesEnum.EXPATIENT_ADMIN) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_ADMIN)
		)
	);
	acl.rule(PagePermissionEnum.UNDUE_LIST_AM, (user: UserInfo) =>
		user && (
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR_MANAGER) ||
			user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR) ||
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_VALIDATOR)
		)
	);
	acl.rule(PagePermissionEnum.EXPORTS_DGOS, (user: UserInfo) =>
		user && user.roles.includes(AccessMasterRolesEnum.NATIONAL_DGOS)
	);
	acl.rule(PagePermissionEnum.UNDUE_LIST, 'Project', (user: UserInfo, project: any) =>
		user && hasRolesForProject(TechnicalRolesEnum.UNDUE_LIST, user, project) ||
		user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR_MANAGER) ||
		user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR) ||
		user.roles.includes(AccessMasterRolesEnum.NATIONAL_VALIDATOR)
	);
	acl.rule(PagePermissionEnum.UNDUE_ADD, 'Project', (user: UserInfo, project: any) =>
		user && hasRolesForProject(TechnicalRolesEnum.UNDUE_ADD, user, project) ||
		user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR_MANAGER) ||
		user.roles.includes(AccessMasterRolesEnum.LIQUIDATOR) ||
		user.roles.includes(AccessMasterRolesEnum.NATIONAL_VALIDATOR)
	);
	acl.rule(PagePermissionEnum.UNDUE_ADD_AM, (user: UserInfo) =>
		user && (
			user.roles.includes(AccessMasterRolesEnum.NATIONAL_VALIDATOR)
		)
	);

	return acl;
}
